import axios from 'axios';

const formApi = axios.create({
  baseURL: 'https://cms.progadget.pl/wp-json/contact-form-7/v1/contact-forms/',
});

export default formApi;
